/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Report_Group_InsufficientInputs */

const en_us2_progress_report_group_insufficient = /** @type {(inputs: Progress_Report_Group_InsufficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough data yet`)
};

const pt_br2_progress_report_group_insufficient = /** @type {(inputs: Progress_Report_Group_InsufficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poucos dados ainda`)
};

const es_419_progress_report_group_insufficient = /** @type {(inputs: Progress_Report_Group_InsufficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún pocos datos`)
};

const pt_pt2_progress_report_group_insufficient = /** @type {(inputs: Progress_Report_Group_InsufficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda há poucos dados`)
};

const fr_fr2_progress_report_group_insufficient = /** @type {(inputs: Progress_Report_Group_InsufficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore assez de données`)
};

const de_de2_progress_report_group_insufficient = /** @type {(inputs: Progress_Report_Group_InsufficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch zu wenig Daten`)
};

const it_it2_progress_report_group_insufficient = /** @type {(inputs: Progress_Report_Group_InsufficientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora pochi dati`)
};

/**
* | output |
* | --- |
* | "Not enough data yet" |
*
* @param {Progress_Report_Group_InsufficientInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_group_insufficient = /** @type {((inputs?: Progress_Report_Group_InsufficientInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Group_InsufficientInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_group_insufficient(inputs)
	if (locale === "es-419") return es_419_progress_report_group_insufficient(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_group_insufficient(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_group_insufficient(inputs)
	if (locale === "de-DE") return de_de2_progress_report_group_insufficient(inputs)
	if (locale === "it-IT") return it_it2_progress_report_group_insufficient(inputs)
	return en_us2_progress_report_group_insufficient(inputs)
});
export { progress_report_group_insufficient as "progress-report.group_insufficient" }